<template>
  <div id="explore">
    <!-- LIST VIEW -->
    <div class="list-view">
      <div class="exploration-header">
        <!-- EXPLORATION TITLE -->
        <div class="exploration-title">{{ exploration.title }}</div>
      </div><!-- /.exploration-header -->
      <div class="container">
        <div v-for="point in exploration.points" class="card mt-2 ml-2">
          <div class="card-body">
            {{ point.title }}
            <button v-if="point.nearby == true" class="btn btn-warning">Unlock!</button>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div><!-- /.container -->
    </div><!-- /.list-view -->
  </div>
</template>

<script>
  const fb = require('../firebaseConfig.js')
  import moment from 'moment'

  export default {
    data() {
      return {
        exploration: {},
        point: {},
        mode: this.$route.params.mode
      }
    },
    components: {
    },
    created() {
      this.getExploration(this.$route.params.id)
      this.getUserLocation()
    },
    watch: {
      '$route.params.mode': function (mode) {
        this.mode = mode
      }
    },
    methods: {
      calcDistance(lat1, lon1, lat2, lon2) {
        var R = 6371; // Radius of the earth in km
        var dLat = (lat2 - lat1) * Math.PI / 180;  // deg2rad below
        var dLon = (lon2 - lon1) * Math.PI / 180;
        var a =
           0.5 - Math.cos(dLat)/2 +
           Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
           (1 - Math.cos(dLon))/2;

        return R * 2 * Math.asin(Math.sqrt(a));
      },
      checkLocations(userPosition) {
        const userLat = userPosition.coords.latitude
        const userLon = userPosition.coords.longitude

        let self = this

        for (let i = 0; i < self.exploration.points.length; i++) {
          let pointLat = self.exploration.points[i].coordinates.latitude
          let pointLon = self.exploration.points[i].coordinates.longitude
          let distance = self.calcDistance(userLat, userLon, pointLat, pointLon)
          if (distance < 0.15) {
            self.exploration.points[i].nearby = true
          } else {
            self.exploration.points[i].nearby = false
          }
          console.log(self.exploration.points[i].nearby)
        }

        this.getUserLocation()
      },
      getUserLocation() {
        let self = this
        setTimeout(function() {
          navigator.geolocation.getCurrentPosition(self.checkLocations)
        }, 3000)
      },
      getExploration(id) {
        fb.explorationsCollection.doc(id).onSnapshot(doc => {
          let exploration = doc.data()
          exploration.id = doc.id
          this.exploration = exploration
          // Check for a point slug
          let slug = this.$route.params.slug
          if (slug) {
            // Loop through points looking for this slug
            for (let i = 0; i < exploration.points.length; i++) {
              // Check for a match
              if (slug == exploration.points[i].slug) {
                // Assign the matching point
                this.point = this.exploration.points[i]
              }
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Explore.vue